import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faTachometerAlt,
    faUserFriends,
    faComments,
    faGlobeAmericas,
    faUserAlt,
    faUsers,
    faDesktop,
    faCaretDown,
    faCog,
    faCogs,
    faQuestionCircle,
    faExclamationTriangle,
    faTrashAlt,
    faHdd,
    faImages,
    faTv,
    faStarHalfAlt,
    faListAlt,
    faSyncAlt,
    faLightbulb,
    faBatteryThreeQuarters,
    faAngleDoubleRight,
    faSearch,
    faSuitcase,
    faSearchPlus,
    faPlusCircle,
    faArrowAltCircleRight,
    faSortDown,
    faCheck,
    faTimes,
    faHourglassHalf,
    faUniversity,
    faHistory,
    faPlug
} from '@fortawesome/free-solid-svg-icons'

// Ícones das categorias da Central de ajuda (/ajuda) — SVG, imunes ao subset do webfont
import {
    faComments as faCatComments,
    faAddressCard,
    faFileContract,
    faBoxes,
    faDollarSign,
    faFileInvoiceDollar,
    faInfoCircle,
    faTags,
    faWrench,
    faFileInvoice,
    faHandshake,
    faChartBar,
    faShoppingCart,
    faShoppingBag,
    faCalculator,
    faBook,
    faCalendarAlt,
    faCode,
    faTruck,
    faGlobe,
    faSignature,
    faBalanceScale,
    faFileAlt,
    faClock,
    faCheckCircle,
    faEye,
    faThumbsUp,
    faThumbsDown,
    faExclamationTriangle as faCatWarning
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(
    faCatComments, faAddressCard, faFileContract, faBoxes, faDollarSign,
    faFileInvoiceDollar, faInfoCircle, faTags, faWrench, faFileInvoice,
    faHandshake, faChartBar, faShoppingCart, faShoppingBag, faCalculator,
    faBook, faCalendarAlt, faCode, faTruck, faGlobe, faSignature,
    faBalanceScale, faFileAlt, faClock, faCheckCircle, faEye,
    faThumbsUp, faThumbsDown, faCatWarning
)
library.add(
    faTachometerAlt,
    faUserFriends,
    faComments,
    faGlobeAmericas,
    faUserAlt,
    faUsers,
    faDesktop,
    faCaretDown,
    faCog,
    faCogs,
    faQuestionCircle,
    faExclamationTriangle,
    faTrashAlt,
    faHdd,
    faImages,
    faTv,
    faStarHalfAlt,
    faListAlt,
    faSyncAlt,
    faLightbulb,
    faBatteryThreeQuarters,
    faAngleDoubleRight,
    faSearch,
    faSuitcase,
    faSearchPlus,
    faPlusCircle,
    faArrowAltCircleRight,
    faSortDown,
    faCheck,
    faTimes,
    faHourglassHalf,
    faUniversity,
    faHistory,
    faPlug
)
Vue.component('font-awesome-icon', FontAwesomeIcon)